import React, { useRef, useEffect } from "react";
import MessageBubble from "./MessageBubble";
import SiraguLogo from "./SiraguLogo";
import "./ChatWindow.css";

function ChatWindow({ messages, loading, onSend, onFeedback }) {
  const bottomRef = useRef(null);

  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages, loading]);

  return (
    <div className="chat-window">
      {messages.map((msg) => (
        <MessageBubble
          key={msg.localId || Math.random()}
          message={msg}
          onSend={onSend}
          onFeedback={onFeedback}
        />
      ))}
      {loading && (
        <div className="loading-indicator">
          <SiraguLogo size={26} active />
          <div className="typing-dots" aria-label="Siragu is thinking">
            <span />
            <span />
            <span />
          </div>
          <span className="loading-text">Siragu is thinking…</span>
        </div>
      )}
      <div ref={bottomRef} />
    </div>
  );
}

export default ChatWindow;
